<script>
import {SystemApi} from "@core/api";
import { BFormGroup, BFormInput, BBadge } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
    components: {BFormGroup, BFormInput, vSelect, BBadge},
    props: {
        identity: {
            default() {
                return {
                    type: {},
                    value: null
                }
            }
        },
        vertical: {
            default: false
        },
        view: {
            default: false
        },
        errors: {
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            selectedType: this.identity ? this.identity.type : null,
            types: [],
            value: this.identity ? this.identity.value : null,
            highlightState: false
        };
    },
    methods: {
        onTypeChange() {
            this.emit();
        },
        emit() {
            this.$emit('input', {
                type: this.selectedType,
                value: this.value
            });
        },
        validate() {
            this.highlightState = true;

            return this.selectedType && this.value;
        }
    },
    created() {
        SystemApi.legalIdentity.getTypes().then(r => {
            this.types = r.data;
        });
    },
    watch: {
        identity() {
            if (null === this.identity) {
                this.value = null;
                this.selectedType = null;
            } else {
                this.value = this.identity.value;
                this.selectedType = this.identity.type;
            }
        }
    }
}
</script>

<template>
    <div>
        <div v-if="view">
            <div v-if="vertical" class="text-center">
                <div><strong>{{ identity.value }}</strong></div>
                <div><b-badge>{{ identity.type.title }}</b-badge></div>
            </div>
            <div v-else>
                <b-badge>{{ identity.type.title }}</b-badge><strong class="pl-50">{{ identity.value }}</strong>
            </div>
        </div>
        <div v-else class="row">
            <div :class="vertical ? 'col-md-12' : 'col-md-6'">
                <b-form-group
                    :label="$t('Component(Label):legal-identity-type')"
                    label-for="name"
                >
                    <v-select
                        v-model="selectedType"
                        class="bg-white"
                        label="title"
                        :placeholder="$t('Component(Placeholder):legal-identity-type')"
                        :options="types"
                        @input="onTypeChange"
                    />
                    <small v-if="highlightState && !selectedType" class="text-danger">
                        {{ $t('Component(ValidationMessage):legal-identity-type-must-be-entered') }}
                    </small>
                </b-form-group>
            </div>
            <div :class="vertical ? 'col-md-12' : 'col-md-6'">
                <b-form-group
                    :label="$t('Component(Label):legal-identity-value')"
                    label-for="name"
                >
                    <b-form-input
                        id="name"
                        v-model="value"
                        :state="highlightState && !value ? false : null"
                        @input="emit"
                        :placeholder="$t('Component(Placeholder):legal-identity-value')"
                    />
                    <div v-for="error in errors">
                        <small class="text-danger">{{ error }}</small>
                    </div>
                </b-form-group>
            </div>
        </div>
    </div>
</template>
